import React from 'react'
import { Grid, Typography } from '@mui/material'

export interface DetailItemProps {
  label: string
  value?: React.ReactNode
  children?: React.ReactNode
}

const DetailItem: React.FC<DetailItemProps> = ({ label, value, children }) => (
  <Grid {...{ xs: 12, sm: 6 }}>
    <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
      {label}
    </Typography>
    {children ? (
      children
    ) : (
      <Typography variant="body1" sx={{ fontWeight: '500', wordWrap: 'break-word' }}>
        {value ?? 'N/A'}
      </Typography>
    )}
  </Grid>
)

export default DetailItem
